import type {ApiResponseData} from '@frontend/types/AppTypes'
import {handleSuccessResponse} from 'swayok-react-mdb-ui-kit/helpers/api/ApiRequestErrorHelpers'
import {ApiRequestService} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'
import type {
    ExecutorToReviewData,
    PostedExecutorReviewData,
    PostedSellerReviewData,
    SellerToReviewData,
} from './MyReviewsModuleTypes'

// API отзывов пользователя (входящие и исходящие).
export const MyReviewsApi = {

    // Получить список отправленных отзывов о продавцах и исполнителях услуг.
    async getPostedSellerReviews(
        limit: number,
        offset: number = 0
    ): Promise<PostedSellerReviewsListResponseData> {
        return ApiRequestService
            .get<PostedSellerReviewsListResponseData>('/v1/cabinet/reviews/posted', {
                limit: String(limit),
                offset: String(offset),
            })
            .then(response => response.data)
    },

    // Получить список продавцов и исполнителей услуг, на которых можно оставить отзыв.
    async getSellersToReview(
        limit: number,
        offset: number = 0
    ): Promise<SellersToReviewResponseData> {
        return ApiRequestService
            .get<SellersToReviewResponseData>('/v1/cabinet/reviews/pending', {
                limit: String(limit),
                offset: String(offset),
            })
            .then(response => response.data)
    },

    // Добавить отзыв о продавце.
    async addReviewFoChat(
        this: void,
        chatId: number,
        rating: number,
        review: string | null
    ): Promise<void> {
        return ApiRequestService
            .post<ApiResponseData>('/v1/reviews/chat', {
                chatId,
                rating,
                review,
            })
            .then(response => {
                handleSuccessResponse(response)
            })
    },
}

interface PostedSellerReviewsListResponseData extends ApiResponseData {
    records: (PostedSellerReviewData | PostedExecutorReviewData)[]
}

interface SellersToReviewResponseData extends ApiResponseData {
    records: (SellerToReviewData | ExecutorToReviewData)[]
}
